import { AIGradientIcon } from "common/src/ai/components/gradient-icon";
import { Sparkles } from "lucide-react";
import { _ } from "i18n";
import { Tooltip } from "ui-kit-v2/src/tooltip/tooltip";

export const CoachReviewsAIGeneratedIcon = () => {
	return (
		<Tooltip label={_("game.coachReviews.aiGeneratedIcon.tooltip")}>
			<AIGradientIcon icon={Sparkles} size={16} />
		</Tooltip>
	);
};
